import CSSModules from 'react-css-modules'
import React, { PropTypes } from 'react'

import styles from './grid-error-modal.css'

const GridErrorModal = ({ closeModal, message }) => (
  <div styleName="content">
    <h1 styleName="title">Sorry</h1>
    <p styleName="description">{message}</p>
    <div styleName="actions">
      <button styleName="button" onClick={closeModal}>Ok</button>
    </div>
  </div>
)

GridErrorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  message: PropTypes.string,
}

export default CSSModules(GridErrorModal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-error-modal/grid-error-modal.js
 **/